// Copyright ©️ 2026 eVolve MEP, LLC

import { FONT_FAMILY_OPTIONS } from 'components/Autodesk/extensions/MarkupModeExtension/PropertyPanelFields/fontConstants';

type FontFamilyFieldProps = { id: string; label: string; value: string };

export const FontFamilyField = ({ id, label, value }: FontFamilyFieldProps) => (
  <div className="field-wrapper">
    <label htmlFor={id}>{label}</label>
    <div className="select-wrapper">
      <select id={id} name={id} defaultValue={value}>
        {FONT_FAMILY_OPTIONS.map((o) => (
          <option key={o.value} value={o.value} style={{ fontFamily: o.value }}>
            {o.label}
          </option>
        ))}
      </select>
      <div className="adsk-icon-arrow" />
    </div>
  </div>
);
